import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import EastIcon from "@mui/icons-material/East";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { CountryFlag } from "../../CommonPage/MarketFlow/CountryFlag";
import { useLanguage } from "../../context/LanguageContext";
const Ourinvest = () => {
  const theme = useTheme();
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: false, // whether animation should happen only once
    });
  }, []);

  const [countryCode, setCountryCode] = useState("us"); // default to US
  const [flagUrl, setFlagUrl] = useState(""); // fallback

  console.log("flagUrlflagUrlflagUrl", flagUrl);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { language, translations } = useLanguage();

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country_code?.toUpperCase(); // e.g., 'IN'

        console.log("User Country Code:", ipCountryCode);

        const matchedCountry = CountryFlag.find(
          (c) => c.countrycode === ipCountryCode
        );

        if (matchedCountry?.flag) {
          setFlagUrl(matchedCountry.flag);
        }
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);

  // useEffect(() => {
  //   const fetchCountryCode = async () => {
  //     try {
  //       const response = await axios.get("https://ipapi.co/json/");
  //       const ipCountryCode = response.data.country_code?.toUpperCase(); // 'IN', 'US', etc.
  //       console.log("adsgafsg", ipCountryCode);
  //       const mockCountryCode = "IN"; // or "US", "GB", etc.

  //       // Find country in your JSON
  //       const matchedCountry = CountryFlag.find(
  //         (c) => c.countrycode === ipCountryCode ?? "IN"
  //       );

  //       if (matchedCountry?.flag) {
  //         setFlagUrl(matchedCountry.flag);
  //       }
  //     } catch (error) {
  //       console.error("IP fetch failed:", error);
  //     }
  //   };

  //   fetchCountryCode();
  // }, []);

  return (
    <Box sx={{ py: { xs: "2rem", md: "10rem" } }}>
      <Box textAlign="center" mb={5}>
        <Typography variant="h2">
          {translations[language]?.ourInvestors?.title}{" "}
          <span style={{ color: "#2494C9" }}>
            {translations[language]?.ourInvestors?.favorites}{" "}
          </span>
        </Typography>
        <Typography
          sx={{
            fontSize: "25px",
            color: "gray",
            fontWeight: "500",
            fontFamily: "SF Pro Display",
            mt: 2,
          }}
        >
          {translations[language]?.ourInvestors?.subtitle}
        </Typography>
      </Box>

      <Grid
        container
        spacing={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "5rem",
        }}
      >
        {/* Left Card */}
        <Grid item xs={12} sm={6}>
          <Card
            {...(!isSmallScreen && { "data-aos": "fade-right" })}
            sx={{
              width: { xs: "100%", sm: 660 },
              height: { xs: "auto", sm: 300 },
              backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695068/Favo1_ygho4k.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: "none",
              borderRadius: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: { xs: 2, sm: 4 },
              color: "#fff",
              overflow: "hidden",
              position: "relative",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Box
              sx={{
                maxWidth: { xs: "100%", sm: 400 },
                mb: { xs: 0, sm: 0 },
                textAlign: { xs: "left", sm: "left" },
                padding: { xs: "10px", md: "0px" },
              }}
            >
              <Typography
                variant="h3"
                color="#fff"
                sx={{
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  // "&:hover": {
                  //   transform: "translateY(-5px)",
                  // },
                }}
              >
                {translations[language]?.ourInvestors?.metaTrader?.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  fontWeight: "500",
                  fontSize: "18px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  // "&:hover": {
                  //   transform: "translateY(-5px)",
                  // },
                }}
              >
                {translations[language]?.ourInvestors?.metaTrader?.description}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mb: 3,
                  flexWrap: "wrap",
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
              >
                <Button
                  component="a"
                  href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                  disableRipple
                  sx={{
                    background: "#1f201D",
                    // border: "1px solid gray",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1,
                    width: { xs: "100%", sm: "auto" },
                    justifyContent: "center",
                    fontSize: { xs: "12px", sm: "inherit" },
                  }}
                >
                  <img
                    src="/Images/google.png"
                    alt="App Store"
                    style={{
                      width: "35px",
                      height: "35px",
                      objectFit: "contain",
                    }}
                  />
                  <Box sx={{ textAlign: "left" }}>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: 12,
                        display: { xs: "none", md: "block" },
                      }}
                    >
                      {
                        translations[language]?.ourInvestors?.metaTrader
                          ?.downloadOn
                      }
                    </Typography>
                    <Typography
                      sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}
                    >
                      {
                        translations[language]?.ourInvestors?.metaTrader
                          ?.playStore
                      }
                    </Typography>
                  </Box>
                </Button>

                <Button
                  component="a"
                  href="https://apps.apple.com/us/app/metatrader-5/id413251709"
                  target="_blank"
                  rel="noopener noreferrer"
                  disableRipple
                  sx={{
                    background: "#1f201D",
                    // border: "1px solid gray",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1,
                    width: { xs: "100%", sm: "auto" },
                    justifyContent: "center",
                    fontSize: { xs: "12px", sm: "inherit" },
                  }}
                >
                  <img
                    src="/Images/apppple.png"
                    alt="App Store"
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "contain",
                    }}
                  />
                  <Box sx={{ textAlign: "left" }}>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: 12,
                        display: { xs: "none", md: "block" },
                      }}
                    >
                      {
                        translations[language]?.ourInvestors?.metaTrader
                          ?.downloadOn
                      }
                    </Typography>
                    <Typography
                      sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}
                    >
                      {
                        translations[language]?.ourInvestors?.metaTrader
                          ?.appStore
                      }
                    </Typography>
                  </Box>
                </Button>
              </Box>

              <Typography
                component="a"
                href="https://portal.bbcorp.trade/auth/jwt/sign-up/auth/jwt/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                variant="h5"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "18px",
                  color: "#fff",
                  fontWeight: 500,
                  justifyContent: { xs: "center", sm: "flex-start" },
                  "&:hover": {
                    textDecoration: "none",
                    color: "gray",
                  },
                }}
              >
                {translations[language]?.ourInvestors?.metaTrader?.openAccount}
                &nbsp;
                <EastIcon />
              </Typography>
            </Box>
            {/* 
              <Box
                component="img"
                src="/Images/phone.png"
                alt="MetaTrader App"
                sx={{
                  position: { xs: "relative", sm: "absolute" },
                  right: { xs: "auto", sm: 0 },
                  bottom: { xs: "auto", sm: 0 },
                  height: { xs: 90, sm: 300 },
                  margin: { xs: "0 auto", sm: 0 },
                  display: { xs: "none", md: "block" },
                  transition: "transform 0.5s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              /> */}
          </Card>
        </Grid>
        {/* Right Card */}
        <Grid item xs={12} sm={6}>
          <Card
            {...(!isSmallScreen && { "data-aos": "fade-left" })}
            sx={{
              width: { xs: "100%", sm: 660 },
              height: { xs: "auto", md: 300 },
              backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695071/Favo2_gafuto.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: "none",
              borderRadius: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: { xs: 3, md: 4 },
              color: "#fff",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box sx={{ maxWidth: 400 }}>
              <Typography
                variant="h3"
                color="#fff"
                sx={{
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  // "&:hover": {
                  //   transform: "translateY(-5px)",
                  // },
                }}
              >
                {translations[language]?.Bonus?.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  fontWeight: "500",
                  fontSize: "18px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  // "&:hover": {
                  //   transform: "translateY(-5px)",
                  // },
                }}
              >
                {translations[language]?.Bonus?.subtitle}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 7,
                  fontWeight: "500",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  // "&:hover": {
                  //   transform: "translateY(-5px)",
                  // },
                }}
              >
                {translations[language]?.Bonus?.favorites}
              </Typography>

              <Typography
                variant="h5"
                // component="a"
                // href="https://portal.bbcorp.trade/auth/jwt/sign-up/auth/jwt/sign-in"
                // target="_blank"
                // rel="noopener noreferrer"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "gray",
                  fontWeight: 500,
                  marginTop: "12px",
                  "&:hover": {
                    textDecoration: "none",
                    color: "gray",
                  },
                }}
              >
                {translations[language]?.Competitions?.openAccount}&nbsp;
                {/* <EastIcon /> */}
              </Typography>
            </Box>
            {/* 
              <Box
                component="img"
                src="/Images/gift.png"
                alt="Bonus Gift"
                sx={{
                  position: "absolute",
                  right: 0,
                  bottom: 0,
                  height: { xs: 90, md: 210 },
                  transition: "transform 0.5s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              /> */}
          </Card>
        </Grid>
        <Grid
          container
          spacing={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={6}>
            <Card
              {...(!isSmallScreen && { "data-aos": "fade-right" })}
              sx={{
                width: { xs: "100%", sm: 660 },
                height: { xs: "auto", md: 300 },
                backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695072/Favo3_kcnmkk.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 5,
                display: "flex",
                alignItems: "center",
                boxShadow: "none",
                justifyContent: "space-between",
                padding: { xs: "50px !important", md: "30px" },
                color: "#fff",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Box sx={{ maxWidth: 400 }}>
                <Typography
                  variant="h3"
                  color="#fff"
                  sx={{
                    // fontWeight: "600",
                    mb: 1,
                    ml: { xs: "-15px !important", md: "-15px !important" },
                    // fontSize: "40px",
                    // fontFamily: "SF Pro Display",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    // "&:hover": {
                    //   transform: "translateY(-5px)",
                    // },
                  }}
                >
                  {translations[language]?.Competitions?.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 11,
                    fontWeight: "500",
                    fontSize: "18px",
                    ml: { xs: "-15px !important", md: "-15px !important" },
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    // "&:hover": {
                    //   transform: "translateY(-5px)",
                    // },
                  }}
                >
                  {translations[language]?.Competitions?.subtitle} <br />
                  {translations[language]?.Competitions?.subtitle1}
                </Typography>
                <Box
                  sx={{ mb: { xs: "-20px !important", md: "0px !important" } }}
                >
                  <Typography
                    variant="h5"
                    // component="a"
                    // href="#"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "gray",
                      fontWeight: 500,
                      marginTop: "12px",
                      ml: { xs: "-15px !important", md: "-15px !important" },

                      fontSize: "16px",
                      "&:hover": {
                        textDecoration: "none",
                        color: "gray",
                        cursor: "pointer",
                      },
                    }}
                  >
                    {translations[language]?.Competitions?.openAccount}&nbsp;
                    {/* <EastIcon /> */}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card
              {...(!isSmallScreen && { "data-aos": "fade-left" })}
              sx={{
                width: { xs: "100%", sm: 660 },
                height: { xs: "auto", md: 300 },
                // backgroundImage: "url('/Images/Favo4.png')",
                backgroundColor: "rgba(243, 245, 247, 1)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: { xs: 3, md: 4 },
                color: "#fff",
                overflow: "hidden",
                boxShadow: "none",
                position: "relative",
              }}
            >
              <Box sx={{ maxWidth: 550, mb: 2.5 }}>
                <Typography
                  variant="h3"
                  color="#000"
                  sx={{
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    // "&:hover": {
                    //   transform: "translateY(-5px)",
                    // },
                  }}
                >
                  {translations[language]?.deposit?.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 11,
                    color: "#000",
                    width: "450px",
                    fontWeight: "500",
                    fontSize: "18px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    // "&:hover": {
                    //   transform: "translateY(-5px)",
                    // },
                  }}
                >
                  {translations[language]?.deposit?.subtitle}
                  <br /> {translations[language]?.deposit?.subtitle1}
                  <br /> {translations[language]?.deposit?.subtitle2}
                </Typography>

                {/* <Typography
                    component="a"
                    href="https://portal.bbcorp.trade/auth/jwt/sign-up/auth/jwt/sign-in"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="h5"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "#2494C9",
                      fontWeight: 500,
                      "&:hover": {
                        textDecoration: "none",
                        color: "gray",
                      },
                    }}
                  >
                    {translations[language]?.deposit?.openAccount} &nbsp;
                    <EastIcon />
                  </Typography> */}
              </Box>
              <Box
                component="img"
                src={flagUrl}
                // src="/Images/usaHalf.png"
                alt="Bonus Gift"
                sx={{
                  position: "absolute",
                  right: "-30px",
                  bottom: "-30px",

                  height: { xs: 140, md: 190 },
                  borderTopLeftRadius: "50%",
                  borderBottomLeftRadius: "50%",
                  // transition: "transform 0.5s ease-in-out",
                  // "&:hover": {
                  //   transform: "scale(1.1)",
                  // },
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Ourinvest;
